import { css } from 'styled-components'

export const makeCalcCss = (cssProperty: string, calc: string): css => css`
  ${cssProperty}: calc(${calc});
  ${cssProperty}: -moz-calc(${calc});
  ${cssProperty}: -webkit-calc(${calc});
`
